// removed by extract-text-webpack-plugin
module.exports = {"html--modalOpen":"html--modalOpen","modal":"modal","modal--open":"modal--open","modal__dialog":"modal__dialog","modal__content__title":"modal__content__title","modal__content__text":"modal__content__text","modal__content__btn":"modal__content__btn","isMobile":"isMobile","modal__content__btn__text2":"modal__content__btn__text2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/modal.scss
// module id = 575
// module chunks = 0